import { useState, useEffect, useRef } from "react";
import { Col, Row, Container } from "react-bootstrap";
import Layout from "@/components/layout";
import styles from "@/styles/AboutUs.module.css";
import { healerServices } from "@/services/healerServices";
import Head from "next/head";
import Link from "next/link";

const PrivacyPolicy = (props) => {
  const [privacyPolicy, setPrivacyPolicy] = useState(
    props?.privacyPolicy ?? {}
  );
  const [showSideButton, setShowSideButton] = useState(false);
  const firstSectionRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!firstSectionRef.current) return;

      const sectionTop = firstSectionRef.current.getBoundingClientRect().bottom;

      setShowSideButton(sectionTop < 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  //const [apiLoader, setApiLoader] = useState(false);

  //   const fetchPrivacyPolicy = async () => {
  //     const res = await healerServices.getPrivacyPolicy();
  //     setApiLoader(false);
  //     if (res.status) {
  //       setPrivacyPolicy(res.data);
  //     } else {
  //         toast.error(res.message, {
  //             autoClose: 5000,
  //         });
  //     }
  // };

  // useEffect(() => {
  //     fetchPrivacyPolicy();
  // }, []);

  return (
    <>
      <>
        <Head>
          <title>{privacyPolicy?.meta?.og_title}</title>
          <meta name="title" content={privacyPolicy?.meta?.meta_title}></meta>
          <meta
            name="description"
            content={privacyPolicy?.meta?.meta_description}
          ></meta>
          <meta
            name="keywords"
            content={privacyPolicy?.meta?.meta_keywords}
          ></meta>
          <meta property="og:type" content="website"></meta>
          <meta
            property="og:title"
            content={privacyPolicy?.meta?.og_title}
          ></meta>
          <meta
            property="og:image"
            content={privacyPolicy?.meta?.og_image}
          ></meta>
          <link
            rel="canonical"
            href="https://www.zenkify.com/privacy-policy"
          ></link>
          <meta
            property="og:description"
            content={privacyPolicy?.meta?.meta_description}
          ></meta>
          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content={privacyPolicy?.meta?.meta_title}
          />
          <meta
            name="twitter:description"
            content={privacyPolicy?.meta?.meta_description}
          />
          <meta name="twitter:image" content={privacyPolicy?.meta?.og_image} />
          <meta
            property="og:url"
            content="https://www.zenkify.com/privacy-policy"
          />
          <meta property="og:site_name" content="Zenkify" />
          <meta property="og:image:alt" content="zenkify privacy-policy" />
          <meta
            property="og:image"
            content={privacyPolicy?.meta?.og_image}
          ></meta>
        </Head>
        <section
          ref={firstSectionRef}
          className={`${styles["section-banner"]} ${styles["banner-page"]}`}
          style={{ background: "url(/images/about-banner.jpg)" }}
        >
          <Container>
            <Row>
              <Col md={8} className="m-auto">
                <div className={styles["inner-content"]}>
                  <h2 className={styles["banner-title"]}>Privacy Policy</h2>
                  <p>
                    Your privacy matters to us. Zenkify is committed to
                    safeguarding your personal information. We collect and use
                    data for providing services, improving user experience, and
                    ensuring security. Rest assured, your information is handled
                    with utmost care and not shared without consent. For more
                    details, please review our comprehensive Privacy Policy.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="privacy-policy-sec">
          <Container>
            <Row>
              <Col md={12} className="mb-3"></Col>
              <Col md={12} className="mb-3">
                {privacyPolicy?.description ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: privacyPolicy?.description,
                    }}
                  />
                ) : (
                  <p>Not Specified.</p>
                )}
              </Col>
            </Row>
          </Container>
        </section>
        <Link
          id="floatingBook"
          className="floating-book"
          aria-label="Book a FREE call now"
          href="/healers"
          style={{ opacity: showSideButton ? 1 : 0 }}
        >
          Book a FREE call now
        </Link>
      </>
    </>
  );
};

export default PrivacyPolicy;

PrivacyPolicy.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>;
};

// ssr
export async function getServerSideProps() {
  const fetchPrivacyPolicy = async () => {
    try {
      const res = await healerServices.getPrivacyPolicy();
      if (res.status) {
        return res.data;
      }
    } catch (error) {
      console.error("Error fetching slider data:", error);
    }
  };

  const privacyPolicy = (await fetchPrivacyPolicy()) ?? {};

  // Pass data to the page via props
  return { props: { privacyPolicy } };
}
